module.exports = __webpack_public_path__ + "static/media/apple-icon-180x180.537f3c92.png";